import styled from "styled-components";

// && {} is to get around the currently more specific rule from styles.css
export const StyledCheckbox = styled.span`
  color: #e10000;
  font-size: 14px;
  padding-left: 10px;
  margin-right: 5px;
  margin-top: 2rem;
  margin-bottom: 0.25rem;
`;
